<template>
  <div class="popular-dishes-box">
    <div>
      <h5>{{$t('stats.popular')}}</h5>
      <ol>
        <li v-for="(dish,index) in list" :key="`${dish._id}-${index}`">{{ dish.name }}</li>
      </ol>
    </div>
    <h5>{{$t('stats.popular')}}</h5>
    <ol>
      <li v-for="(dish,index) in list" :key="`${dish._id}-${index}`">{{ dish.name }}</li>
    </ol>
    <h5>{{$t('stats.popular')}}</h5>
    <ol>
      <li v-for="(dish,index) in list" :key="`${dish._id}-${index}`">{{ dish.name }}</li>
    </ol>
  </div>
</template>

<style scoped>
h5 {
  font-size: 2.2vh;
  margin-bottom: 0;
}

.popular-dishes-box {
  width: 73.5vh;
  max-height: 37.5vh;
  min-height: 37.5vh;
  color: #ededed;
  padding: 3.3vh;
  overflow: auto;
  border-radius: 1vh;
  background: #1d1d1b;
}

.popular-dishes-box ol {
  padding-left: 2.2vh;
  margin: 1.1vh 0 0 0;
  min-height: 25vh;
  font-size: 2vh;
}

ol li {
  line-height: 1.2;
  padding-top: 1.1vh;
}
li {
  width: 100%;
}
</style>

<script>
export default {
  props: {
    list: Array,
    waiters: Array,
    clients: Array,
  },
};
</script>